<template>
  <router-view/>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  // provide() {
  //   return {
  //     reload: this.reload,
  //   };
  // },
  data() {
    return {
      isAlive: true,
    };
  },
  computed: {
    ...mapGetters({
      online: 'app/online',
    }),
  },
  created() {
    this.$auth.setApplication(this);
  },
  methods: {
    // reload() {
    //   this.isAlive = false;
    //   // eslint-disable-next-line
    //   this.$nextTick(function () {
    //     this.isAlive = true;
    //   });
    // },
  },
};
</script>
